import get from 'lodash-es/get'
import * as React from 'react'

import { shortenNumber } from '../../../../../../common/utils/formatString'
import { IItem } from '../../../../../../typings/searchResults'
import StarRating from '../../../../../shared/components/starRating'

import * as styles from './rating.module.css'

interface IProps {
  item: IItem
}

const Rating = ({ item }: IProps) => {
  const { rating } = item
  const ratingCount = get(item, 'rating.count')

  return (
    <div className={styles.rating}>
      <StarRating rating={rating.rating} className={styles.starRating} />
      <span className={styles.starRatingCount}>
        ({shortenNumber(ratingCount)})
      </span>
    </div>
  )
}

export default Rating
